import React from "react";
import "./welcomePage.css";
import { baseUrl } from "../../../api";

class Login extends React.Component {
    state = {
        email: "",
        password: "",
        loading: false,
        inputErr: false,
        inputErrMsg: "",
        increment: 0,
        loading: false,
    };

    componentDidMount() { }

    componentDidUpdate() {
        if (this.state.inputErr) {
            setTimeout(() => {
                this.setState({ ...this.state, inputErr: false });
            }, 3000);
        }
    }

    validEmail(val) {
        if (
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                val
            )
        ) {
            return true;
        } else {
            return false;
        }
    }

    login() {
        if (!this.validEmail(this.state.email)) {
            return this.setState({
                ...this.state,
                inputErr: true,
                inputErrMsg: "L'identifiant est non valide",
            });
        }
        if (!this.state.password) {
            return this.setState({
                ...this.state,
                inputErr: true,
                inputErrMsg: "Veuillez renseigner un mot de passe",
            });
        }
        this.setState({ ...this.state, loading: true });
        let payload = {
            user_email: this.state.email,
            user_password: this.state.password,
        };

        fetch(`${baseUrl}/admin_login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((res) => {
                if (res?.statusCode === 400) {
                    this.setState({ ...this.state, inputErr: true });
                    this.setState({
                        ...this.state,
                        inputErrMsg: "adresse e-mail / mot de passe non valide(s)",
                        loading: false,
                    });
                } else if (res?.statusCode === 200) {
                    localStorage.setItem(
                        "user_details",
                        JSON.stringify(res?.response?.detail)
                    );
                    localStorage.setItem("token", res?.response?.token);
                    //this.props.login();
                    this.props.login(res?.response?.detail);
                }
            })
            .catch((error) => {
                this.setState({
                    ...this.state,
                    inputErr: true,
                    loading: false,
                });
                this.setState({
                    ...this.state,
                    inputErrMsg: "Invalid Email/Password",
                });
            });
    }

    render() {
        return (
            <div className="wrapper">
                <center>
                    <div className="sub-title font-family text-center text-dark mb-2"
                        style={{ maxWidth: "470px", minWidth: "300px" }}>
                        Bienvenue sur l'espace de visioconférences{" "}
                    </div>
                </center>
                <div className="row">
                    <center>
                        <div className="input-wrapper-login">
                            <div className="mb-2">
                                <input
                                    type="text"
                                    placeholder="Identifiant"
                                    className="input"
                                    value={this.state.email}
                                    onChange={(e) =>
                                        this.setState({
                                            ...this.state,
                                            email: e.target.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="mb-2">
                                <input
                                    type="password"
                                    placeholder="Mot de passe"
                                    className="input phone-number"
                                    value={this.state.password}
                                    onChange={(e) =>
                                        this.setState({
                                            ...this.state,
                                            password: e.target.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </center>
                    <div className="text-center">
                        <button
                            className="btn btn-dark login-btn"
                            onClick={() => this.login()}
                            style={{ minWidth: "200px" }}
                        >
                            S'identifier
                        </button>
                    </div>

                    {this.state.inputErr && (
                        <div className="err text-center mt-2">
                            {this.state.inputErrMsg}
                        </div>
                    )}
                    {this.state.loading && (
                        <div className="loadinglog text-center">Chargement en cours...</div>
                    )}
                </div>
                {/* History and details section */}
            </div>
        );
    }
}

export default Login;
